import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import toast from './plugins/tost';
import router from './router/index';
import ymap from '@/plugins/ymap';
import store from './stores/index';
import axios from 'axios';

Vue.prototype.axios = axios;

new Vue({
  vuetify,
  router,
  ymap,
  toast,
  store,
  render: h => h(App),
}).$mount('#app');